import * as preact from "preact";

import { imageUrl, srcset } from "../foundation/utils/image";

function ResponsiveImage(props) {
    const { asset, descriptors, ...rest } = props;
    const assetUrl = imageUrl(asset);

    return preact.h("img", Object.assign({
        src: assetUrl,
        srcset: srcset(assetUrl, descriptors)
    }, rest));
}

export default ResponsiveImage;
